import { updateContactList } from "./contactsView.js";
import { topLevelContactList } from "./contactsView.js";
const scannerEl = document.querySelector('#reader');

export function setupScanner() {
    const scannerError = document.querySelector('#scanner-error');
    const scannerSuccess = document.querySelector('#scanner-success');
    const scannerSuccessMessage = scannerSuccess.querySelector('h2');

    function onScanSuccess(decodedText, decodedResult) {
        // handle the scanned code as you like, for example:

        if (!JSON.parse(decodedText)) {
            scannerSuccess.style.display = "none";
            scannerError.style.display = "grid";
        }

        const contactObject = JSON.parse(decodedText);

        scannerSuccessMessage.innerText = `Contact successfully added: ${contactObject.name}`;
        scannerSuccess.style.display = "grid";
        scannerError.style.display = "none";

        document.querySelector('#html5-qrcode-button-camera-stop').click();

        topLevelContactList.list.push(contactObject);
        updateContactList(topLevelContactList);

        document.querySelector('#html5-qrcode-button-camera-start').addEventListener('click', () => {
            scannerSuccess.style.display = "none";
            scannerError.style.display = "none";
        }, { once: true })
    }

    function onScanFailure(error) {

    }

    function initialiseScanner() {
        let html5QrcodeScanner = new Html5QrcodeScanner(
            "reader",
            {
                fps: 5,
                qrbox: { width: 320, height: 320 },
                rememberLastUsedCamera: false,
                supportedScanTypes: [
                    Html5QrcodeScanType.SCAN_TYPE_CAMERA
                ]
            },
            /* verbose= */ false);
        html5QrcodeScanner.render(onScanSuccess, onScanFailure);
    }


    initialiseScanner();
}